import { createFileRoute } from "@tanstack/react-router";
import { AboutPage } from "../../../features/about";

export const Route = createFileRoute("/$lang/_layout/about")({
  component: AboutPage,
});
